import React from 'react';
import { UserStateContextProvider } from './user-state-context';
import { SocketContextProvider } from './socket-context';
import { CustomerDrawerContextProvider } from './customer-drawer-context';
import { ModalContextProvider } from './modal-context';
import { BrowserNotificationsProvider } from './browser-notifications';
import { AgentContextProvider } from './agent-context';
import { NotificationsContextProvider } from './notifications-context';
export const ContextProviders = ({
  children
}) => {
  return <UserStateContextProvider>
      <NotificationsContextProvider>
        <SocketContextProvider>
          <AgentContextProvider>
            <CustomerDrawerContextProvider>
              <ModalContextProvider>
                <BrowserNotificationsProvider>{children}</BrowserNotificationsProvider>
              </ModalContextProvider>
            </CustomerDrawerContextProvider>
          </AgentContextProvider>
        </SocketContextProvider>
      </NotificationsContextProvider>
    </UserStateContextProvider>;
};